// T BY DANIEL — THEME JS

// Scroll reveal
const revealEls = document.querySelectorAll('.r');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('vis');
      observer.unobserve(e.target);
    }
  });
}, { threshold: 0.08 });
revealEls.forEach(el => observer.observe(el));

// Cart quantity update on change
document.querySelectorAll('.qty-input').forEach(input => {
  input.addEventListener('change', () => {
    input.closest('form')?.submit();
  });
});
